import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useCommonService } from '@/shared/api';
import * as abTests from './ab-tests';

const storeKey = 'ABTestStore';

export const useABTestStore = defineStore(
  storeKey,
  () => {
    const abDistribution = ref<Record<string, string>>({});
    const abDistributionRequestResolved = ref(false);

    const isPrefillExperiment = computed(() => {
      const { AB_TESTS, AB_GROUPS } = abTests;
      return abDistribution.value[AB_TESTS.PREFILL] === AB_GROUPS.B;
    });

    const isCoreExperiment = computed(() => {
      const { AB_TESTS, AB_GROUPS } = abTests;
      return abDistribution.value[AB_TESTS.CORE_INTEGRATION] === AB_GROUPS.B;
    });

    const getABDistribution = async (codes: string[]) => {
      if (abDistributionRequestResolved.value && Object.keys(abDistribution.value).length > 0) {
        return codes.map(code => abDistribution.value[code] ?? null);
      }

      try {
        const result = await useCommonService().getABTests({ codes });
        abDistribution.value = result ?? {};
        abDistributionRequestResolved.value = true;
      } catch (error) {
        console.error(error);
        return null;
      }

      return codes.map(code => abDistribution.value[code] ?? null);
    };

    const experimentGroups = computed(() =>
      Object.entries(abDistribution.value).map(([key, value]) => `${key}-${value}`),
    );

    return {
      abDistribution,
      abDistributionRequestResolved,
      isPrefillExperiment,
      isCoreExperiment,
      experimentGroups,
      getABDistribution,
    };
  },
  {
    persist: {
      key: storeKey,
      storage: localStorage,
    },
  },
);
